import axios from "axios";
import api from "./Urls";

export const CLOUDINARY_PURPOSES = Object.freeze({
  ITEM_IMAGE: "ITEM_IMAGE",
  PROFILE_IMAGE: "PROFILE_IMAGE",
  CHAT_IMAGE: "CHAT_IMAGE",
  CHAT_VIDEO: "CHAT_VIDEO",
  CHAT_AUDIO: "CHAT_AUDIO",
  NOTICE_IMAGE: "NOTICE_IMAGE",
});

export const uploadDirectToCloudinary = async (
  file,
  purpose,
  { onProgress } = {}
) => {
  if (!file) {
    throw new Error("File is required");
  }

  const signatureResponse = await api.post("/api/cloudinary/signature", {
    purpose,
  });

  const {
    cloudName,
    apiKey,
    resourceType,
    timestamp,
    folder,
    signature,
  } = signatureResponse.data || {};

  if (
    !cloudName ||
    !apiKey ||
    !resourceType ||
    !timestamp ||
    !folder ||
    !signature
  ) {
    throw new Error("Invalid Cloudinary upload signature response");
  }

  const formData = new FormData();
  formData.append("file", file);
  formData.append("api_key", apiKey);
  formData.append("timestamp", String(timestamp));
  formData.append("folder", folder);
  formData.append("signature", signature);

  const uploadUrl = `https://api.cloudinary.com/v1_1/${encodeURIComponent(
    cloudName
  )}/${encodeURIComponent(resourceType)}/upload`;

  const response = await axios.post(uploadUrl, formData, {
    onUploadProgress: (event) => {
      if (!onProgress || !event.total) return;
      onProgress(Math.min(100, Math.round((event.loaded * 100) / event.total)));
    },
  });

  const data = response.data || {};

  if (!data.secure_url || !data.public_id) {
    throw new Error("Cloudinary upload did not return an asset URL");
  }

  return {
    secureUrl: data.secure_url,
    publicId: data.public_id,
    resourceType: data.resource_type || resourceType,
    format: data.format || null,
    bytes: Number(data.bytes || file.size || 0),
    width: data.width ?? null,
    height: data.height ?? null,
    duration: data.duration ?? null,
    originalFilename: data.original_filename || file.name || null,
  };
};
